import { Event } from '../Event'
import { Identity } from '../../constants'

export interface FullPageTakeoverModalSubmittedEventProperties {
  placement: string
}

export class FullPageTakeoverModalSubmittedEvent extends Event<
  FullPageTakeoverModalSubmittedEventProperties
> {
  static displayName = 'Full Page Takeover Modal Submitted'

  static allowedIdentities = [Identity.Guest, Identity.Consumer]
}
